//Parse through API path
const pathParser = path => {
  const regex = /[/][a-zA-Z0-9]*/gm;
  let match, sanitized;
  let matches = [];

  while ((match = regex.exec(path)) !== null) {
    if (match.index === regex.lastIndex) {
      regex.lastIndex++;
    }
    sanitized = match[0].substring(match[0].indexOf("/") + 1);
    matches.push(sanitized);
  }

  return matches;
};

export default pathParser;



// WEBPACK FOOTER //
// ./src/pages/util/pathParser.js